import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["info", "button"]
  static values = { url: String }

  generate(event) {
    event.preventDefault()

    this.buttonTarget.disabled = true
    this.clearInfo()

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
        "Accept": "application/json",
      },
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        this.showInfo(data.info, ok ? "success" : "error")
        if (ok) {
          this.buttonTarget.disabled = true
        } else {
          this.buttonTarget.disabled = false
        }
      })
      .catch(() => {
        this.showInfo("There was a problem generating a signal for this log.", "error")
        this.buttonTarget.disabled = false
      })
  }

  showInfo(message, type) {
    this.infoTarget.textContent = message
    this.infoTarget.classList.remove("hidden")

    if (type === "error") {
      this.infoTarget.classList.add("text-red-600", "dark:text-red-400")
      this.infoTarget.classList.remove("text-green-600", "dark:text-green-400")
    } else {
      this.infoTarget.classList.add("text-green-600", "dark:text-green-400")
      this.infoTarget.classList.remove("text-red-600", "dark:text-red-400")
    }
  }

  clearInfo() {
    this.infoTarget.textContent = ""
    this.infoTarget.classList.add("hidden")
  }
}
